module.exports = __webpack_public_path__ + "img/13.e015341c.png";